
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Box,
  Typography,
  Grid,
  Paper,
} from "@mui/material";
import api from "../../../services/api";

export default function CohortPopup() {
  const [isOpen, setIsOpen] = useState(false);
  const [cohorts, setCohorts] = useState([]);
  const [selectedCohort, setSelectedCohort] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    fetchCohortWindow();
  }, []);

  const fetchCohortWindow = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const res = await api.get("/internship/longterm-select/cohort-list/", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setStatus(res.data.status);

      if (res.data.status === "open") {
        setCohorts(res.data.cohorts);
        setIsOpen(true);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleCohortClick = (id) => {
    const last = cohorts[cohorts.length - 1].id;
    const prev = cohorts[cohorts.length - 2].id;

    if (id === last) {
      // Selecting last cohort → auto-select (prev, last)
      setSelectedCohort(prev);
    } else {
      setSelectedCohort(id);
    }
  };

  const handleSubmit = async () => {
    if (!selectedCohort) return;

    setSubmitLoading(true);
    try {
      const token = localStorage.getItem("accessToken");

      await api.post(
        "/internship/longterm-select/submit/",
        {
          cohort1: selectedCohort,
          cohort2: selectedCohort + 1,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setIsOpen(false);
    } catch (err) {
      console.error(err);
      alert("Failed to submit!");
    }
    setSubmitLoading(false);
  };

  if (!isOpen || status !== "open") return null;

  const last = cohorts[cohorts.length - 1];
  const isLastSelected = selectedCohort === last.id;

  return (
    <Dialog open={isOpen} disableEscapeKeyDown maxWidth="sm" fullWidth>
      <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
        Select Cohort Pair For Long-Term Apsche Certificate
      </DialogTitle>

      <DialogContent dividers>
        <Typography sx={{ textAlign: "center", mb: 2, color: "red" }}>
          Please select a cohort. The next consecutive cohort will be automatically paired.
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" py={3}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Grid container spacing={2} justifyContent="center">
              {cohorts.map((c) => {
                const isPaired =
                  selectedCohort !== null &&
                  (c.id === selectedCohort || c.id === selectedCohort + 1);

                return (
                  <Grid item key={c.id}>
                    <Paper
                      elevation={isPaired ? 6 : 1}
                      sx={{
                        p: 2,
                        textAlign: "center",
                        cursor: "pointer",
                        width: 140,
                        borderRadius: 2,
                        backgroundColor: isPaired ? "#2e7d32" : "grey.100",
                        color: isPaired ? "white" : "black",
                        "&:hover": {
                          backgroundColor: isPaired ? "#1b5e20" : "grey.200",
                        },
                      }}
                      onClick={() => handleCohortClick(c.id)}
                    >
                      <Typography sx={{ fontWeight: "bold" }}>
                        Cohort {c.id}
                      </Typography>

                      <Typography sx={{ fontSize: "12px", mt: 0.5 }}>
                        {c.duration}
                      </Typography>
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>

            {selectedCohort && (
              <Paper
                elevation={3}
                sx={{
                  mt: 3,
                  px: 2.5,
                  py: 1.5,
                  mx: "auto",
                  maxWidth: 320,
                  textAlign: "center",
                  backgroundColor: "rgba(46,125,50,0.12)",
                  border: "1px solid #2e7d32",
                  borderRadius: 3,
                  fontWeight: 600,
                  color: "#2e7d32",
                }}
              >
                ✅ Selected Pair: Cohort {selectedCohort} & Cohort{" "}
                {selectedCohort + 1}
              </Paper>
            )}
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          fullWidth
          disabled={!selectedCohort || submitLoading}
          onClick={handleSubmit}
          sx={{ fontWeight: "bold", py: 1.2 }}
        >
          {submitLoading ? "Submitting..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
